import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "title"
};
const _hoisted_2 = {
  class: "p-l-30"
};
const _hoisted_3 = {
  class: "dialog-footer"
};
import { ref, useTemplateRef, nextTick } from "vue";
import api from "@/api/login";
import { ElMessage } from "element-plus";
import { useI18n } from "vue-i18n";
export default {
  __name: 'kfToggleDia',
  emits: ["handleSuccess"],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const {
      t
    } = useI18n();
    const showDialog = ref(false);
    const multiple = ref(false);
    const emit = __emit;
    const open = (isMultiple = false) => {
      /*
        isMultiple - 是否多选
      */
      multiple.value = isMultiple;
      showDialog.value = true;
      nextTick(() => {
        kfRef.value.getSelectList();
      });
    };
    const btnLoading = ref(false);
    const kfRef = useTemplateRef("kfRef");
    const handleConfirm = async () => {
      if (!kfRef.value.serviceId.length) {
        return ElMessage.warning(t("conversation.distribution.agentSelect"));
      }
      try {
        btnLoading.value = true;
        await api.autoAssignStatus({
          kfIds: kfRef.value.serviceId
        });
        showDialog.value = false;
        ElMessage.success(t("conversation.serviceList.toggleSuccess"));
        emit("handleSuccess");
      } finally {
        btnLoading.value = false;
      }
    };
    // 弹窗关闭
    const handleClose = () => {
      kfRef.value.serviceId = [];
    };
    __expose({
      open
    });
    return (_ctx, _cache) => {
      const _component_Kf = _resolveComponent("Kf");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: showDialog.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => showDialog.value = $event),
        width: "600px",
        onClose: handleClose
      }, {
        header: _withCtx(() => [_createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$t("common.selectAgentToggleStatus")), 1)]),
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_button, {
          type: "primary",
          size: "large",
          loading: btnLoading.value,
          onClick: handleConfirm
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("action.confirmBtn")), 1)]),
          _: 1
        }, 8, ["loading"]), _createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = $event => showDialog.value = false),
          size: "large"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("action.cancel")), 1)]),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_Kf, {
          multiple: multiple.value,
          ref_key: "kfRef",
          ref: kfRef
        }, null, 8, ["multiple"])])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
};